import { loginPageTranslations as loginPageTranslationsEn } from '@I18n/en/login_page';

export const loginPageTranslations = {
  footer: {
    privacy_policy: { text: 'Politique de confidentialité', link: '#' },
    support: { text: 'Support', link: '#' },
  },
  messages: {
    logging_in: 'Redirection...',
    link_expired: 'Le lien a expiré. Veuillez vous connecter ou réessayer.',
    forgot_password_success: {
      header: 'Vérifiez votre adresse e-mail',
      subheader:
        "Un e-mail contenant un lien de validation a été envoyé à %{email}.\nVous n'avez pas reçu cet e-mail ? Vérifiez votre dossier de spam.",
    },
    first_connection_success: {
      header: 'Créez votre mot de passe',
      subheader: 'Vous avez reçu un email avec un lien pour créer votre mot de passe à %{email}.',
      note: "Vous n'avez pas reçu cet email ? Vérifiez vos courriers indésirables (spam)",
    },
    forgot_password: {
      header: 'Réinitialisez votre mot de passe',
      subheader:
        'Saisissez votre adresse e-mail pour demander un lien de réinitialisation du mot de passe',
      failed:
        'Échec de l’envoi de l’e-mail de réinitialisation du mot de passe. Réessayez plus tard ou contactez le support.',
      failed_activation:
        'Échec de l’activation du compte. Vérifiez que le code et l’adresse e-mail sont corrects ou contactez le support.',
      cta_text: 'Réinitialiser le mot de passe',
    },
    first_connection: {
      header: 'Pour commencer, veuillez vous identifier',
      subheader: {
        has_no_phonenumber: 'Saisissez votre adresse e-mail et votre code entreprise',
        has_phonenumber: 'Saisissez votre adresse e-mail',
      },
    },
    change_password: {
      header: 'Changer le mot de passe',
      subheader: 'Saisissez votre mot de passe et confirmez-le',
      failed:
        'Échec de la réinitialisation de votre mot de passe. Réessayez plus tard ou contactez le support.',
      weak_password: 'Ce mot de passe est facile à deviner, veuillez en choisir un plus sécurisé.',
      weak_password_has_words: 'Votre mot de passe ne peut pas contenir de mots.',
      weak_password_has_consecutive_chars:
        'Votre mot de passe ne peut pas contenir plus de deux fois le même caractère consécutivement.',
      disabled:
        'La réinitialisation du mot de passe est désactivée. Veuillez contacter le support.',
      description: {
        header: 'Votre mot de passe de 12 caractères minimum doit contenir :',
        line1:
          'Lettres : une majuscule et une minuscule (pas de noms propres, de noms communs ou de séquences de clavier)',
        line2: 'Chiffres sans séquences logiques (123456) ou identiques (11111)  ',
        line3: 'Un caractère spécial',
      },
      cta_text: 'Confirmer',
    },
    landing: {
      header: {
        line1: "Bienvenue sur l'espace entreprise",
        line2: 'AXA Mon Epargne Entreprises',
      },
      mlk_header: {
        line1: "Bienvenue sur l'espace entreprise",
        line2: 'Malakoff Mon Epargne Entreprises',
      },
      first_connection: 'Créer un compte',
      login: 'Se connecter',
      footer: 'Nous sommes une entreprise réglementée.',
      footer_link: 'En savoir plus',
    },
    login: {
      header: 'Se connecter',
      subheader: 'Saisissez votre e-mail et votre mot de passe',
    },
    verify_email: {
      header: 'Vérifiez vos e-mails',
      subheader: 'Nous vous avons envoyé un lien pour vous connecter',
      note: 'Ouvrez-le depuis votre boîte de réception pour accéder à votre Espace Entreprise',
    },
    verify_otp: {
      header: 'Vérifiez votre connexion',
      subheaderSupport: 'Saisissez le code de vérification reçu',
      subheaderEmail:
        'Nous avons envoyé un code de confirmation à votre adresse e-mail. Veuillez le saisir ci-dessous.',
      subheaderAlternateEmail:
        'Nous avons envoyé un code de confirmation à votre 2e e-mail pour la 2FA (%{alternateEmail}). Veuillez le saisir ci-dessous.',
      subheaderSMS:
        'Nous avons envoyé un SMS contenant un code de confirmation à votre numéro de téléphone. Veuillez le saisir ci-dessous.',
      failed: 'Code de confirmation invalide',
      expired: 'Le code de confirmation a expiré. Veuillez réessayer.',
      testCode: 'Code de test : %{code}',
    },
    add_alternate_email: {
      title: 'Ajouter un e-mail alternatif',
      description_add_email:
        'Veuillez ajouter un 2e e-mail pour la 2FA en contactant le service client AXA.',
      description_support_phone:
        'Vous pouvez appeler le %{phoneNumber} de 8h30 à 18h (heure de Paris, CET/CEST).',
      description_contact_support:
        'En dehors de ces horaires, veuillez contacter l’administrateur de votre entreprise.',
      back_to_login: 'Retour à la connexion',
    },
    verify_phone_number: {
      header: {
        code_and_phone: 'Ajoutez votre numéro de téléphone mobile et votre code entreprise',
        add: 'Ajoutez votre numéro de téléphone',
        verify: 'Confirmez votre numéro de téléphone',
      },
      subheader: {
        code_and_phone:
          'Identifiez-vous avec votre code Entreprise. Votre numéro de téléphone mobile est requis pour améliorer la sécurité de vos transactions',
        add: 'Votre numéro de téléphone est requis pour renforcer la sécurité de vos transactions',
        verify:
          'Si le numéro affiché ci-dessous est incorrect, veuillez contacter le service client AXA',
      },
      contact_us: 'Contactez-nous',
      cta_text: 'Confirmer',
      failed: 'Échec de la vérification du numéro de téléphone',
    },
    contact_us: {
      header: 'Contactez-nous',
      content:
        "Veuillez contacter le service client AXA au 09 70 80 85 95 pour obtenir un code entreprise qui vous permettra d'accéder à votre espace.",
      cta_text: 'Continuer',
    },
    form: {
      email_placeholder: 'E-mail',
      password_placeholder: 'Votre mot de passe',
      external_code_enterprise_placeholder: 'Code entreprise',
      external_code_enterprise: {
        helper_dialog: {
          title: 'Code entreprise',
          text: "Votre code entreprise vous a été fourni par lettre ou par téléphone via le service client AXA. Vous n'avez pas reçu le code ? Veuillez contacter le service client au 09 70 80 85 95.",
        },
      },
      confirm_password_placeholder: 'Confirmez votre mot de passe',
      phone_number_placeholder: 'Numéro de téléphone mobile',
      remember_me: 'Se souvenir de cet appareil',
      forgot_password: 'Mot de passe oublié ? Réinitialisez-le ici',
      first_connection: 'Première connexion ?',
      errors: {
        invalid_type: "Type d'entrée invalide",
        required: 'Requis',
        email_format: 'Format email invalide',
        invalid_credentials: 'Adresse e-mail ou mot de passe invalide',
        password_length_min: 'Le mot de passe doit contenir au moins 12 caractères',
        password_length_max: 'Le mot de passe doit contenir au maximum 128 caractères',
        password_req_uppercase: 'Le mot de passe doit contenir une lettre majuscule',
        password_req_lowercase: 'Le mot de passe doit contenir une lettre minuscule',
        password_req_number: 'Le mot de passe doit contenir un chiffre',
        password_req_symbol: 'Le mot de passe doit contenir un caractère spécial',
        password_mismatch: 'Les mots de passe doivent être identiques',
        phoneNumber_format: 'Numéro de téléphone invalide',
        phoneNumber_tooLong: 'Le numéro de téléphone est trop long',
        phoneNumber_tooShort: 'Le numéro de téléphone est trop court',
        phoneNumber_invalidCountryCode: 'Indicatif pays invalide',
      },
      cta_text: 'Se connecter',
    },
  },
} satisfies typeof loginPageTranslationsEn;
